export const APAC_FORM_UI_NAME = "apac-form-ui";
export enum ApacFormUiComponent {
  TextField = "TextField",
  SelectField = "SelectField",
  PhoneNumberField = "PhoneNumberField",
  FormInputContainer = "FormInputContainer",
}
